import { Box, List, ListItem, Button, Typography } from '@mui/material'
import Header from 'components/Header'
import { boxOperations } from 'constant'
import { DailyOrderType } from 'constant'
import { OrderContext } from 'contexts/OrderContextProvider'
import useDailyOrder from 'hooks/useDailyOrder'
import { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const BoxOperations = () => {
  const navigate = useNavigate()
  const { company } = useParams()
  const {
    dailyOrders,
    handleFetchDailyOrders,
    selectedDailyOrderClass,
    setSelectedDailyOrderClass,
    filteredDailyOrdersByClass,
    selectedDailyOrderBatchIndex,
    setSelectedDailyOrderBatchIndex
  } = useContext(OrderContext)
  const { calculateOrdersLeft } = useDailyOrder()

  const getBatchIndexByLabel = (label?: string | null): number => {
    const normalized = `${label || ''}`.trim().toUpperCase()
    if (!/^[A-Z]+$/.test(normalized)) return Number.MAX_SAFE_INTEGER
    let result = 0
    for (let i = 0; i < normalized.length; i++) {
      result = result * 26 + (normalized.charCodeAt(i) - 64)
    }
    return result - 1
  }
  const getBatchesByLabel = (orders: any[]) => {
    const grouped = new Map<string, any[]>()
    for (const order of orders) {
      const label = `${order?.batchLabel || ''}`.trim().toUpperCase()
      if (!label) continue
      if (!grouped.has(label)) grouped.set(label, [])
      grouped.get(label)!.push(order)
    }
    return Array.from(grouped.entries())
      .sort((a, b) => getBatchIndexByLabel(a[0]) - getBatchIndexByLabel(b[0]))
      .map(([label, batchOrders]) => ({ label, orders: batchOrders }))
  }
  const labeledBatches = getBatchesByLabel(filteredDailyOrdersByClass)

  useEffect(() => {
    handleFetchDailyOrders(
      `${company}`,
      DailyOrderType.BoxCodeSalesOrder,
      undefined,
      true
    )
  }, [])

  const selectedBatchOrders =
    selectedDailyOrderBatchIndex !== undefined
      ? (labeledBatches[selectedDailyOrderBatchIndex]?.orders ?? [])
      : []
  const ordersLeftCount =
    selectedDailyOrderBatchIndex !== undefined
      ? calculateOrdersLeft(selectedBatchOrders)
      : calculateOrdersLeft(filteredDailyOrdersByClass)
  return (
    <Box>
      <Header buttonLink={`/${company}/daily-order`} />
      {!selectedDailyOrderClass ? (
        <List
          sx={{
            '& .MuiListItemButton-root': {
              color: '#607998',
              fontFamily: 'sans-serif',
              fontWeight: 600
            },
            '& a': {
              textDecoration: 'none'
            }
          }}
        >
          {dailyOrders.length > 0 ? (
            dailyOrders.map(order => (
              <Box key={order.class}>
                <ListItem>
                  <Button
                    variant='contained'
                    sx={{
                      width: '100%',
                      textAlign: 'center',
                      textTransform: 'none',
                      fontSize: '26px',
                      padding: '50px 20px',
                      backgroundColor: '#364c63',
                      marginBottom: '20px'
                    }}
                    onClick={() => {
                      setSelectedDailyOrderClass(order.class)
                      setSelectedDailyOrderBatchIndex(undefined)
                    }}
                  >
                    {order.class}
                  </Button>
                </ListItem>
              </Box>
            ))
          ) : (
            <Typography variant='h5' textAlign='center' marginTop='30px'>
              No order found in this field!
            </Typography>
          )}
        </List>
      ) : (
        <Box>
          <Box sx={{ margin: '20px', position: 'relative' }}>
            <Button
              variant='outlined'
              onClick={() => {
                setSelectedDailyOrderClass(undefined)
                setSelectedDailyOrderBatchIndex(undefined)
              }}
              sx={{
                position: 'absolute'
              }}
            >
              Back to class
            </Button>
            <Typography
              variant='h5'
              sx={{ fontWeight: 600, textAlign: 'center' }}
            >
              {ordersLeftCount} orders left
            </Typography>
          </Box>
          <List>
            {labeledBatches.map((batch, index) => (
              <Box key={index}>
                <ListItem>
                  <Button
                    variant='contained'
                    sx={{
                      width: '100%',
                      textAlign: 'center',
                      textTransform: 'none',
                      fontSize: '20px',
                      backgroundColor: '#5a7690'
                    }}
                    onClick={() => {
                      if (selectedDailyOrderBatchIndex === index) {
                        setSelectedDailyOrderBatchIndex(undefined)
                      } else {
                        setSelectedDailyOrderBatchIndex(index)
                      }
                    }}
                  >
                    {`${batch.label} (${batch.orders.length})`}
                  </Button>
                </ListItem>
                {selectedDailyOrderBatchIndex === index && (
                  <List
                    sx={{
                      '& .MuiListItemButton-root': {
                        color: '#607998',
                        fontFamily: 'sans-serif',
                        fontWeight: 600
                      },
                      '& a': {
                        textDecoration: 'none'
                      }
                    }}
                  >
                    {boxOperations.map(item => (
                      <ListItem
                        key={`${index}-${item.label}`}
                        sx={{ padding: '10px 20px 20px 20px' }}
                        onClick={() => {
                          navigate(`/${company}${item.path}`)
                        }}
                      >
                        <Button
                          variant='contained'
                          sx={{
                            width: '100%',
                            textAlign: 'center',
                            textTransform: 'none',
                            fontSize: '24px',
                            padding: '28px 20px',
                            backgroundColor: '#364c63'
                          }}
                        >
                          {item.label}
                        </Button>
                      </ListItem>
                    ))}
                  </List>
                )}
              </Box>
            ))}
          </List>
        </Box>
      )}
    </Box>
  )
}

export default BoxOperations
